import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'garage-tool',
  imports: [],
  templateUrl: './garage-tool.component.html',
  styleUrl: './garage-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GarageToolComponent {}
